import { jsx as s, jsxs as p } from "react/jsx-runtime";
import { forwardRef as y, useMemo as o, isValidElement as r } from "react";
import { useStyleConfig as R, chakra as _ } from "@chakra-ui/react";
const b = y(
  ({ __css: i, as: f, children: c, isBold: u, isDisabled: a, leftIcon: t, rightIcon: e, trackId: l, ...n }, m) => {
    const d = R("TextLink", n), x = o(() => typeof t == "function" ? /* @__PURE__ */ s(t, {}) : r(t) ? t : null, [t]), L = o(() => typeof e == "function" ? /* @__PURE__ */ s(e, {}) : r(e) ? e : null, [e]);
    return /* @__PURE__ */ p(
      _.a,
      {
        __css: { ...d, ...i },
        "aria-disabled": a,
        as: f,
        fontWeight: u ? 500 : 400,
        ref: m,
        "track-id": l,
        ...n,
        children: [
          x,
          c,
          L
        ]
      }
    );
  }
);
export {
  b as TextLink
};
//# sourceMappingURL=TextLink.es.js.map
